import AuthController from '../controllers/AuthController';

class AuthModule {
  constructor() {
    this.controller = AuthController;
  }

  async login(credentialResponse) {
    return await this.controller.handleGoogleLogin(credentialResponse);
  }

  async logout() {
    return await this.controller.handleLogout();
  }

  getCurrentUser() {
    return this.controller.getCurrentUser();
  }

  isAuthenticated() {
    return this.controller.isAuthenticated();
  }

  // Método para validar token periódicamente
  validateTokenPeriodically() {
    const interval = setInterval(() => {
      if (!this.isAuthenticated()) {
        clearInterval(interval);
        window.location.href = '/';
      }
    }, 5 * 60 * 1000); // 5 minutos

    return interval;
  }
}

export default new AuthModule();